import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import { ApplyPrePayment, PrePaymentListResp, Response } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PrePaymentService {
  private api: string = CONTROLLERS.PAYMENTS.PRE_PAYMENT;
  constructor(private apiService: ApiService) {}

  getPrePaymentList(
    practiceId: number,
    patientId: number,
    pageNumber: number,
    pageSize: number
  ): Observable<Response<PrePaymentListResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PAYMENTS.PRE_PAYMENT.GET_PRE_PAYMENTS}`,
      {
        practiceId,
        patientId,
        pageNumber,
        pageSize,
      }
    );
  }

  applyPrePayment(applyPrePayment: ApplyPrePayment): Observable<any> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PAYMENTS.PRE_PAYMENT.APPLY_PRE_PAYMENT}`,
      applyPrePayment
    );
  }
}
